/* Copyright (c) 2017 Backpack Health LLC */
/* global IS_ANDROID_BUILD */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ContentFrame from '../../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../components/ScrollAware';
import { AppHeaderScrollableTextWithLanguage } from '../../components/appNav/AppHeaderScrollable';
import Card, { CardSection } from '../../components/card/Card';

import PasswordInput from '../../components/PasswordInput';
import Spacer from '../../components/Spacer';
import PasswordStrengthMeter from '../../components/PasswordStrengthMeter';
import { CheckboxInput } from '../../components/CheckboxInput';

import PasswordStrength from '../../../utilities/PasswordStrength';
import tokenDurations from '../../../constants/tokenDurations';
import ContentWrapper from '../../components/ContentWrapper';

class SetPassword extends React.Component {

  constructor(props) {
    super(props);

    this.onChangePassword = this.onChangePassword.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.toggleKeepSignedIn = this.toggleKeepSignedIn.bind(this);

    this.state = {
      password: '',
      passwordStrength: -1,
      isPasswordValid: false,
      errorMessage: '',
      keepSignedIn: IS_ANDROID_BUILD,
    };
  }

  UNSAFE_componentWillMount() {
    PasswordStrength.requireDependency();
  }

  onChangePassword(e) {
    const value = e.target.value;
    const passwordStrength = PasswordStrength.getScore(value);
    this.setState({
      password: value,
      passwordStrength,
      isPasswordValid: this.props.showStrength ? PasswordStrength.isStrongEnough(passwordStrength) : value.length > 0,
    });
  }

  submitForm(e, callback) {
    e.preventDefault();
    const duration = this.state.keepSignedIn ? tokenDurations.LONG : tokenDurations.SHORT;

    if (this.state.isPasswordValid) {
      callback(this.state.password, duration);
    }
  }

  toggleKeepSignedIn() {
    this.setState({
      keepSignedIn: !this.state.keepSignedIn,
    });
  }

  render() {
    const submitFunction = this.props.onNext || this.props.onSubmit;

    return (
      <div>
        <ScrollAwareContext>
          <ScrollAwareAppNavStep
            cancel={this.props.onCancel ? this.props.onCancel : null}
            goBack={this.props.onBack ? this.props.onBack : null}
            next={this.props.onNext ? (e) => this.submitForm(e, submitFunction) : null}
            submit={this.props.onSubmit ? (e) => this.submitForm(e, submitFunction) : null}
            submitDisabled={!this.state.isPasswordValid}
            color="white"
          />

          <ContentFrame>
            <ScrollAwareScroller>
              <AppHeaderScrollableTextWithLanguage
                id={this.props.title}
                allowLanguageToggle={this.props.allowLanguageToggle}
              />
              <ContentWrapper>
                <Card>
                  <CardSection>
                    <form onSubmit={(e) => { this.submitForm(e, submitFunction); }}>
                      <div>
                        <PasswordInput
                          value={this.state.password}
                          onChange={this.onChangePassword}
                          isInvalid={false}
                          name="password"
                          label={<FormattedMessage id="setPwd.password.field.label" />}
                          initialFocus
                          noForcedHeight
                        >
                          {
                            this.props.showStrength ? (
                              <div>
                                <Spacer size="20" />
                                <PasswordStrengthMeter value={this.state.passwordStrength} />
                              </div>
                            ) : null
                          }
                        </PasswordInput>
                      </div>

                      {
                        this.props.hasKeepSignedIn ? (
                          <CheckboxInput
                            value={true}
                            name="trustBrowser"
                            onChange={this.toggleKeepSignedIn}
                            checked={this.state.keepSignedIn}
                            label={<FormattedMessage id="loginPwd.keepSignedIn.option.label" />}
                          />
                        ) : null
                      }

                      <input type="submit" style={{ visibility: 'hidden', display: 'none' }} />
                    </form>
                  </CardSection>
                </Card>
              </ContentWrapper>
            </ScrollAwareScroller>
          </ContentFrame>
        </ScrollAwareContext>
      </div>
    );
  }
}
SetPassword.propTypes = {
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  onBack: PropTypes.func,
  onSubmit: PropTypes.func,
  onNext: PropTypes.func,
  hasKeepSignedIn: PropTypes.bool,
  showStrength: PropTypes.bool,
  allowLanguageToggle: PropTypes.bool,
};

export default SetPassword;
